
/**
 * LOS TEMAS DE LA BIBLIOTECA.
 *
 * Faina, 26-ago: el filtro de tema es «una palabra del título».
 *
 * ⚠️ LA LISTA ES CURADA, NO SACADA DE LOS TÍTULOS EN AUTOMÁTICO, y conviene
 * saber por qué: se probó lo segundo y las palabras más repetidas de los 94
 * títulos son «nadie» (6), «algo» (5), «también» (4), «sabes» (3) y «eres» (3).
 * Un desplegable con «Algo (5)» y «También (4)» no le sirve a nadie. Los temas
 * de verdad —amor, culpa, perdón, Dios— salían con 3 o 4 piezas cada uno, que es
 * un grupo demasiado pequeño para que filtrar valga la pena.
 *
 * SE BUSCA EN EL TÍTULO Y EN EL ARRANQUE DEL TEXTO, no solo en el título. Es lo
 * que convierte grupos de 3 en grupos de 10 a 40: una canalización sobre el
 * perdón puede llamarse «El enojo con Dios y con la vida», y el lector que
 * filtra por «perdón» la quiere igual.
 *
 * Cada tema lleva sus RAÍCES: «perdon» encuentra perdonar, perdonarte y perdón,
 * sin tildes y sin depender de la conjugación.
 */


/* Los doce. Se ordenan alfabéticamente al mostrarlos, no por tamaño: el lector
   busca un tema concreto, no el más popular. */
const TEMAS_BASE = [
  { id: 'amor', clave: 'tema.amor', texto: 'Amor', raices: ['amor', 'amar', 'querer'] },
  { id: 'perdon', clave: 'tema.perdon', texto: 'Perdón', raices: ['perdon'] },
  { id: 'miedo', clave: 'tema.miedo', texto: 'Miedo', raices: ['miedo', 'ansiedad', 'temor'] },
  { id: 'culpa', clave: 'tema.culpa', texto: 'Culpa', raices: ['culpa', 'verguenza', 'arrepent'] },
  { id: 'dolor', clave: 'tema.dolor', texto: 'Dolor', raices: ['dolor', 'tristeza', 'sufri'] },
  { id: 'familia', clave: 'tema.familia', texto: 'Familia', raices: ['familia', 'madre', 'padre', 'linaje', 'abuela'] },
  { id: 'dios', clave: 'tema.dios', texto: 'Dios', raices: ['dios', 'divin'] },
  { id: 'soledad', clave: 'tema.soledad', texto: 'Soledad', raices: ['soledad', 'solo', 'sola'] },
  { id: 'soltar', clave: 'tema.soltar', texto: 'Soltar', raices: ['soltar', 'suelta', 'entrega'] },
  { id: 'verdad', clave: 'tema.verdad', texto: 'Verdad', raices: ['verdad', 'autentic', 'honest'] },
  { id: 'alma', clave: 'tema.alma', texto: 'Alma', raices: ['alma', 'espiritu'] },
  { id: 'cuerpo', clave: 'tema.cuerpo', texto: 'Cuerpo', raices: ['cuerpo', 'cansancio', 'descans'] }
];

export const slugsDelTema = (doors, id) => {
  const tema = TEMAS_BASE.find((x) => x.id === id);
  const door = tema && doors.find((d) => d.doorId === tema.clave);
  return door ? door.slugs : [];
};

export const temasConPiezas = (doors) => TEMAS_BASE
  .map((tema) => ({ id: tema.id, texto: tema.texto, n: slugsDelTema(doors, tema.id).length }))
  .filter((tema) => tema.n > 0)
  .sort((a, b) => a.texto.localeCompare(b.texto, 'es'));
